import {AffectedComponent, ComponentStatusValue} from "@/lib/types/statuspages.ts";
import ComponentStatusIcon from "@/pages/statuspages/tabs/components/ComponentStatusSelect/ComponentStatusIcon.tsx";

interface IncidentsTableAffectedComponentSubRowProps {
  component: AffectedComponent;
}

export const IncidentsTableAffectedComponentSubRow = ({component}: IncidentsTableAffectedComponentSubRowProps) => (
  <>
    <div className={`d-flex flex-row align-items-center`}>
      <ComponentStatusIcon className="me-2" variant={"icon"} status={component.status as ComponentStatusValue} />
      <span className="pulseTextBodySmall pulse-color-gray-900">{component.name}</span>
    </div>
  </>
);
